<template>
  <footer id="FooterModules" class="column main-color-bg">
    <div class="container">
      <p class="has-text-white-ter">
        {{ $t("copy") }}
        <u>
          <a class="has-text-white" href="mailto:info@ceptinel.com">
            info@ceptinel.com
          </a>
        </u>
      </p>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FooterModules",
  data() {
    return {
      title: "FooterModules",
    };
  },
};
</script>
<i18n>
{
  "es": {
    "copy":"Ceptinel es una empresa  especializa en tecnología regulatoria y prevención de fraude, a través de la detección y alertas oportunas de todo tipo de situaciones anómalas. Recientemente fue escogida como una de las 5 mejores soluciones RegTech en el mundo, entre 479 Startups.  Solicita una Demo a "
  },
  "en": {
    "copy":"Ceptinel is a company specializing in regulatory technology and fraud prevention, through the detection and timely alerts of all kinds of anomalous situations. It was recently chosen as one of the 5 best RegTech solutions in the world, among 479 Startups. Request a Demo to"
  },
  "pt": {
    "copy":"A Ceptinel é uma empresa especializada em tecnologia regulatória e prevenção de fraudes, através da detecção e alerta atempado de todo o tipo de situações anómalas. Recentemente foi eleita uma das 5 melhores soluções RegTech do mundo, entre 479 Startups. Solicite uma demonstração para"
  }
}
</i18n>
